import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faHome,
  faTh,
  faMapMarkerAlt,
  faCog,
  faPhone,
  faEnvelope,
  faKey,
  faCalendarAlt,
  faArrowLeft,
  faChevronRight,
  faSquare,
  faCheckSquare
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faHome)
library.add(faTh)
library.add(faMapMarkerAlt)
library.add(faCog)
library.add(faPhone)
library.add(faEnvelope)
library.add(faKey)
library.add(faCalendarAlt)
library.add(faArrowLeft)
library.add(faChevronRight)
library.add(faSquare)
library.add(faCheckSquare)

Vue.component('font-awesome-icon', FontAwesomeIcon)
